import { sugerirEmail } from '@lib/email-dominio';

/**
 * Chip de sugerencia anti-typo para inputs de email: si el dominio tipeado
 * parece un error de un dominio frecuente ("juan@gmial.com"), ofrece la
 * corrección con UN tap. Nunca bloquea ni autocorrige — si el usuario ignora
 * la sugerencia, el server igual valida que el dominio reciba correo.
 */
export function SugerenciaEmail({
  email,
  onUsar,
}: {
  email: string;
  onUsar: (emailCorregido: string) => void;
}) {
  const sugerido = sugerirEmail(email);
  if (!sugerido) return null;
  return (
    <button
      type="button"
      onClick={() => onUsar(sugerido)}
      style={{
        alignSelf: 'flex-start',
        marginTop: 6,
        padding: '6px 12px',
        borderRadius: 999,
        border: '1px solid var(--color-warning-dark, #B45309)',
        background: 'var(--color-warning-lighter-ext, #FEF3C7)',
        color: 'var(--color-warning-dark, #92400E)',
        fontSize: 13,
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      ¿Quisiste decir <strong>{sugerido}</strong>? Tocá para corregir
    </button>
  );
}
